import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/flatten-pdf/page.tsx");
